export default __webpack_public_path__ + "static/media/frame1.3e5a408b.svg";